import { translation } from "../../../helper/translation"
import ekaplayer1 from '../../../assets/images/project-images/ekaplayer-1-small.png';
import ekaplayerlogo from '../../../assets/images/project-images/ekaiptv-logo.png';
import ekatime1 from '../../../assets/images/project-images/ekatime-1-small.png';
import ekatimelogo from '../../../assets/images/project-images/ekatime-logo.png';
import ekamatchlogo from '../../../assets/images/project-images/ekamatch-logo.png';

export const ContentHomePageTechStack = () => {

    const backendTech = [
        [".NET Core"],
        ["C-Sharp"],
        ["Java"],
        ["MSSQL"],
        ["PostgreSQL",],
        ["MongoDB"],
        ["PHP"]
    ];
    const frontendTech = [
        ["React"],
        ["Angular"],
        ["TypeScript"],
        ["Bootstrap"]
    ];
    const mobileTech = [
        ["React Native"],
        [".NET MAUI"],
        ["Android"],
        ["iOS"],
    ]
    const devOpsTech = [
        ["Microsoft Azure"],
        ["Docker"],
        ["Jenkins"],
        ["AWS"]
    ]

    const techStack = [
        "microsoft-azure.png","dotnetcore.png", "c-sharp-logo.png","dotnet-maui-logo.png","mssql-logo.svg", 
        "php-logo.png", "postgresql-logo.png","mongodb-logo.png",
        "reactjs-logo.png","angular-logo.png","typescript-logo.svg","bootstrap-logo.png","react-native-logo.svg",
        "java-logo.png", "ios-logo.webp", "android-logo.svg","docker-logo.svg","aws-logo.png"
    ]

    return(
        <div className="contest-details">
            <div className="container">
            <div className="row">
                <div className="col-lg-12">
                <div className="top-content">
                    <div className="row">
                    <div className="col-lg-12">
                        <span className="open">{translation("tech-stack")}</span>
                        <span className="open">{translation("Backend")}</span>
                        <span className="open">{translation("frontend")}</span>
                        <span className="open">{translation("database")}</span>
                        <span className="open">{translation("mobile")}</span>
                        <span className="open">{translation("devops")}</span>
                        {/* <span className="wish-list"><i className="fa fa-heart"></i> Add To Your Favorites</span> */}
                    </div>
                    {/* <div className="col-lg-8">
                        <ul>
                            <li><i className="fa fa-medal"></i> <span>Award:</span> $2,400</li>
                            <li><span>Time left:</span> 7 Days</li>
                            <li><span>Participants:</span> 118</li>
                            <li><span>Submittions:</span> 280</li>
                        </ul>
                    </div> */}
                    </div>
                </div>
                </div>
                <div className="col-lg-12">
                <div className="main-content">
                    <h4>{translation("about-me-title")}</h4>
                    <h6>{translation("about-me-heading")}</h6>
                    <span>{translation("welcome-about-me")}</span>

                    <div className="row container-fluid mt-5">
                        <div className="row mb-3">
                            <h5>{translation("here-are-some-recent-projects")}</h5>
                        </div>
                        <div className="row">
                            <div className="col-lg-4 col-sm-6">
                                <div className="popular-item">
                                    <div className="thumb">
                                        <img src={ekaplayerlogo} alt={translation("ekaplayer")} className="mt-2" />
                                        <div className="row mt-3">
                                            <h5>{translation("ekaplayer")}</h5>
                                            <span>{translation("smart-iptv-player")}</span>
                                        </div>
                                    </div>
                                    <div className="border-button">
                                        <a href="/projects">{translation("go-to-projects")}</a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-sm-6">
                                <div className="popular-item">
                                    <div className="thumb">
                                        <img src={ekatimelogo} alt={translation("ekatime")} className="mt-2" />
                                        <div className="row mt-3">
                                            <h5>{translation("ekatime")}</h5>
                                            <span>{translation("time-tracking-system")}</span>
                                        </div>
                                    </div>
                                    <div className="border-button">
                                        <a href="/projects">{translation("go-to-projects")}</a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-sm-6">
                                <div className="popular-item">
                                    <div className="thumb text-center">
                                        <img src={ekamatchlogo} alt={translation("ekamatch")} className="mt-2 w-auto" height={76} />
                                        <div className="row mt-3 text-start">
                                            <h5>{translation("ekamatch")}</h5>
                                            <span>{translation("match-and-player-statistics")}</span>
                                        </div>
                                    </div>
                                    <div className="border-button">
                                        <a href="/projects">{translation("go-to-projects")}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <h4 className="second-title">{translation("tech-stack-heading")}</h4>
                    <div className="row">
                        <div className="col-lg-3 col-6">
                            <div className="item">
                                <span><i className={`fa fa-server`}></i></span>
                                <h5>{translation("backend-db")}<br /></h5>
                                <h6>{translation("backend-description")}</h6>
                                <ul className="tech-stack">
                                    {
                                        backendTech.map((el, index) => {
                                            return(
                                                <li key={index}><h6>{el}</h6></li>
                                            )
                                        })
                                    }
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-6">
                            <div className="item">
                            <span><i className={`fa fa-desktop`}></i></span>
                            <h5>{translation("frontend")}<br /></h5>
                            <h6>{translation("frontend-description")}</h6>
                            <ul className="tech-stack">
                                    {
                                        frontendTech.map((el, index) => {
                                            return(
                                                <li key={index}><h6>{el}</h6></li>
                                            )
                                        })
                                    }
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-6">
                            <div className="item">
                            <span><i className={`fa fa-mobile-alt`}></i></span>
                            <h5>{translation("mobile")}<br /></h5>
                            <h6>{translation("mobile-description")}</h6>
                            <ul className="tech-stack">
                                    {
                                        mobileTech.map((el, index) => {
                                            return(
                                                <li key={index}><h6>{el}</h6></li>
                                            )
                                        })
                                    }
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-6">
                            <div className="item">
                            <span><i className={`fa fa-cogs`}></i></span>
                            <h5>{translation("devops")}<br /></h5>
                            <h6>{translation("devops-description")}</h6>
                            <ul className="tech-stack">
                                    {
                                        devOpsTech.map((el, index) => {
                                            return(
                                                <li key={index}><h6>{el}</h6></li>
                                            )
                                        })
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            {
                                techStack.map((el, index) => {
                                    return(
                                        <div className="tech-stack-image">
                                            <img src={`/assets/images/techstack/${el}`} alt={el} />
                                        </div>
                                    )
                                })
                            }
                            
                        </div>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
    )
}